
import { useState, useCallback } from "react";
import { supabase } from "@/lib/supabase";
import { LeaderboardUser } from "../types/karma-types";
import { getCurrentLevel } from "../utils/karma-utils";

export const useKarmaLeaderboardData = () => {
  const [leaderboard, setLeaderboard] = useState<LeaderboardUser[]>([]);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(true);

  const fetchKarmaLeaderboard = useCallback(async () => {
    setLoadingLeaderboard(true);
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('id, username, full_name, avatar_url, karma_points, karma_level')
        .not('full_name', 'is', null) // Ensure user has a name to be on leaderboard
        .order('karma_points', { ascending: false })
        .limit(10);

      if (error) {
        console.error("Error fetching leaderboard:", error.message);
        setLeaderboard([]);
        return [];
      }
      
      if (data) {
        const formattedData = data.map((user, index) => ({
          ...user,
          rank: index + 1,
          karma_points: user.karma_points || 0,
          karma_level: user.karma_level || getCurrentLevel(user.karma_points || 0),
        }));
        setLeaderboard(formattedData as LeaderboardUser[]);
        return formattedData as LeaderboardUser[];
      }
      return [];
    } catch (error: any) {
      console.error("Failed to fetch leaderboard:", error.message);
      setLeaderboard([]);
      return [];
    } finally {
      setLoadingLeaderboard(false);
    }
  }, []);

  return {
    leaderboard,
    setLeaderboard, // Though usually not set directly from outside
    loadingLeaderboard,
    fetchKarmaLeaderboard,
  };
};
